import { useSelectedOrganization } from "@/hooks/useCurrentUser";
import type { OrganizationRole } from "@/types/organization.type";

/**
 * Org-scoped permissions for the currently selected workspace.
 * Viewers can read + chat; only Owner/Contributor can edit app data.
 * Org-admin (members, rename, social connect, brand creation) is Owner-only.
 *
 * A Guest is one of a brand's clients: scoped to the brands granted to them
 * (the server filters the brand list), with a reduced product — no Home,
 * Signals, Strategy or team calendar; Universe read-only; Trends, References
 * and Workshop usable; the calendar through the client review view.
 */
export function usePermissions() {
  const { selectedOrganization } = useSelectedOrganization();
  const role = (selectedOrganization?.role ?? null) as OrganizationRole | null;
  const isGuest = role === "Guest";

  return {
    role,
    canEdit: role === "Owner" || role === "Contributor",
    isOwner: role === "Owner",
    isViewer: role === "Viewer",
    isGuest,
    /** Workshop work (projects, chat, artifacts): editors and guests. */
    canUseWorkshop: role === "Owner" || role === "Contributor" || isGuest,
  };
}
